import { ReactNode, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

interface SubMenu {
  title: string
  href: string
  hidden?: boolean
}

export const useSideNav = () => {
  const [navItems, setNavItems] = useState<
    Array<{
      text: string
      icon: string
      href: string
      hidden?: boolean
      subMenu: SubMenu[] | []
      notificationElement?: ReactNode
    }>
  >([])
  const [subMenuOpen, setSubMenuOpen] = useState<{
    state: boolean
    index: number | null
  }>({
    state: false,
    index: null,
  })

  const { pathname } = useLocation()

  useEffect(() => {
    setNavItems([
      {
        text: 'Dashboard',
        icon: 'dashboard-icon',
        href: '/dashboard',
        hidden: false,
        subMenu: [],
      },
    ])
  }, [pathname])

  return { navItems, subMenuOpen, setSubMenuOpen }
}
